// extracted by mini-css-extract-plugin
export default {"root":"MemoryAnswersV1_root-DZu","answer":"MemoryAnswersV1_answer-Mzp","white":"MemoryAnswersV1_white-rB_","checked":"MemoryAnswersV1_checked-M8D"};